import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { fetchPlacesSurveyQuestions } from "./thunk";
import { hydrate } from "@/lib";
import type { ResponsePayload, AnswerType, QuestionClass } from "@/types";

interface PlacesFormInitialState {
  questions: Array<QuestionClass>;
  answers: AnswerType;
  answerErrors: AnswerType;
  imageDetails: {
    fileUrl: "";
    name?: "";
    type?: "";
    questionId?: "";
    size?: "";
  };
  status: "idle" | "fetching";
  error: string;
  saving: boolean;
}
const initialState: PlacesFormInitialState = {
  questions: [],
  answers: {},
  imageDetails: {
    fileUrl: "",
    name: "",
    type: "",
    questionId: "",
    size: ""
  },
  answerErrors: {},
  status: "idle",
  saving: false,
  error: ""
};

export const placesSurveyQuestionsSlice = createSlice({
  name: "placesForm",
  initialState,
  reducers: {
    setSaving: (state, action) => {
      state.saving = action.payload;
    },
    setAnswer: (state, action) => {
      const { questionId, answer } = action.payload;

      delete state.answerErrors[questionId];
      state.answers[questionId] = answer;
    },
    setAnswers: (state, action) => {
      state.answers = action.payload;
    },
    setImageDetails: (state, action) => {
      state.imageDetails = action.payload;
    },
    resetAnswers: (state) => {
      state.answers = initialState.answers;
      state.imageDetails = initialState.imageDetails;
    },
    setError: (state, action) => {
      const { questionId, error } = action.payload;

      state.answerErrors[questionId] = error ? error : "";
    },
    clearAllErrors: (state) => {
      state.answerErrors = initialState.answerErrors;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(hydrate, (state, action: PayloadAction<string>) => ({
        ...state,
        ...action.payload[placesSurveyQuestionsSlice.name]
      }))
      .addCase(fetchPlacesSurveyQuestions.pending, (state) => {
        state.status = "fetching";
      })
      .addCase(fetchPlacesSurveyQuestions.fulfilled, (state, action) => {
        state.questions = action.payload;
        state.status = "idle";
      })
      .addCase(fetchPlacesSurveyQuestions.rejected, (state, action) => {
        const { statusText } = action.payload as ResponsePayload;

        state.status = "idle";
        state.error = statusText;
      });
  }
});

export const {
  setAnswer,
  setAnswers,
  setImageDetails,
  setError,
  setSaving,
  resetAnswers,
  clearAllErrors
} = placesSurveyQuestionsSlice.actions;
